import PropTypes from 'prop-types'

import { Icon } from '@redriverpress/system'

import { RichButton, RichButtonGroup } from './RichTextareaComponents'
import { richIconWidth } from './index'

export default function ListGroup({ editor }) {
  const markOptions = [
    {
      icon: 'list',
      clickEvent: () =>
        editor
          .chain()
          .focus()
          .toggleBulletList()
          .run(),
      active: editor.isActive('bulletList'),
    },
    {
      icon: 'list-ol',
      clickEvent: () =>
        editor
          .chain()
          .focus()
          .toggleOrderedList()
          .run(),
      active: editor.isActive('orderedList'),
    },
  ]

  return (
    <RichButtonGroup>
      {markOptions.map(btn => (
        <RichButton
          key={btn.icon}
          onClick={btn.clickEvent}
          secondary={!btn.active}
          small
        >
          <Icon icon={btn.icon} fontSize={0} width={richIconWidth} />
        </RichButton>
      ))}
    </RichButtonGroup>
  )
}

ListGroup.defaultProps = {
  editor: null,
}

ListGroup.propTypes = {
  editor: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool])
  ),
}
